

export const GetMonth = (m) => {
  const months = ['January', 'February', 'March','April','May','June','July','August','September','October','November','December']
  return months[parseInt(m)-1]
}

export const DateDiff = (dateold, datenew) => {
  const mnew = datenew.getMonth()
  const dnew = datenew.getDate()
  const mold = dateold.getMonth()
  const dold = dateold.getDate()
  let diff = datenew - dateold
  if(mold > mnew) diff--
  else
  {
    if(mold == mnew)
    {
      if(dold > dnew) diff--
    }
  }
  return diff
}

export const DayDiff = (d1, d2) => {
  d1 = d1.getTime() / 86400000
  d2 = d2.getTime() / 86400000
  return new Number(d2 - d1).toFixed(0)
}

export const Date_FR = (date) => {
  const month = date.slice(5, 7)
  const year = date.slice(0, 4)
  const day = date.slice(8, 10)

  return `${day}/${month}/${year}`
}

export const DateFormat = (date) => {
  switch (date) {
    case 1: 
    case 31: 
      return `${date}<sup>st</sup>`
    case 2: 
      return `${date}<sup>nd</sup>`
    case 3: 
      return `${date}<sup>rd</sup>`
    default: 
      return `${date}<sup>th</sup>`
  }
}

export const deployCF = (test) => {return true}



// WEBPACK FOOTER //
// ./src/helpers/date.js